import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions/game';
import { request, processErr } from '../api/request';
import {
    GET_GAME_REQUEST,
    GET_HOTS_REQUEST,
    GET_CHALLENGE_REQUEST,
} from '../constant/actionTypes';

const url = '/game';

const getGameApi = (payload) => {
    const gid = payload;

    return request().get(`${url}/info?gid=${gid}&withMeta=true`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data.game,
                    isLoading: false,
                };
            }
        })
        .catch(err => { throw processErr(err) });
}

const getHotsApi = () => {

    return request().get(`${url}/hots`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                };
            }
        })
        .catch(err => { throw processErr(err) });
}

const getChallengeApi = () => {

    return request().get(`${url}/challenge`)
        .then(res => {
            if (res.status === 200) {
                return {
                    ...res.data,
                };
            }
        })
        .catch(err => { throw processErr(err) });
}

function* getGameRequest(action) {
    try {
        const data = yield call(getGameApi, action.payload);
        yield put(actions.getGameSuccess(data));
    } catch (e) {
        yield put(actions.getGameFailure(e));
    }
}

function* getHotsRequest(action) {
    try {
        const data = yield call(getHotsApi, action.payload);
        yield put(actions.getHotsSuccess(data));
    } catch (e) {
        yield put(actions.getHotsFailure(e));
    }
}

function* getChallengeRequest(action) {
    try {
        const data = yield call(getChallengeApi, action.payload);
        yield put(actions.getChallengeSuccess(data));
    } catch (e) {
        yield put(actions.getChallengeFailure(e));
    }
}

const game = [
    takeLatest(GET_GAME_REQUEST, getGameRequest),
    takeLatest(GET_HOTS_REQUEST, getHotsRequest),
    takeLatest(GET_CHALLENGE_REQUEST, getChallengeRequest),
];

export default game;